import {useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppointmentContext } from '../../context/AppointmentContext'
import toast from 'react-hot-toast'

const ExplanationComponent = ({question, type,inputType, next, prev, subState, setSubState}) => {
    const [input, setInput] = useState("")
    const { medicalhistory, setMedicalHistory } = useAppointmentContext();
    const {t} = useTranslation()
    const inputRef = useRef(null)


    useEffect(()=>{
      if(medicalhistory[question?.id]){
       setInput(medicalhistory[question?.id].ans)
      }
      inputRef?.current?.focus()
   },[question])

    const handleInput = (e)=>{
        const value = e.target.value;
        setInput(value);
    }

    const handleNumberInput = (e)=>{
      setInput(e.target.value);
    }

    const handleNext = ()=>{
       if(input === ""){
         toast.error(t("Please provide an answer"));
         return
       }else{
        //  setFormData(prev=>({...prev, [question.id] :{ans : input}}))
        setMedicalHistory((prev) => ({
          ...prev,
          [question.id]: { ans: input },
        }));
         const latestMedicalState = {...medicalhistory,  [question.id]: { ans: input }}
         next(latestMedicalState)
         return
       }
    }

    const handlePrev = ()=>{
        prev();
        return;
    }


    const handleSubState = (e)=>{
        setSubState(prev=>({...prev, [question.id] : {ans:e.target.value}}))
        return
    }


  return (
    <div className="flex flex-col items-center gap-4 w-full flex-1 p-2">
    {type === "sub" ? <label className={`uppercase text-white md:text-xl text-sm md:font-bold flex gap-2`}>
    <span className="underline">{`Q${question.id.toString().charAt(0)}.${question.id.toString().substring(1)}`}:</span>
    <span>{t(question.q)}</span>
    </label>
    :
    <label className={`uppercase text-white md:text-2xl text-base md:font-bold flex gap-2`}>
    <span className="underline">Q{question?.id}:</span>
    <span>{t(question?.q)}</span>
    </label>
    }

    {type !== "sub"? <div className="flex flex-col w-full items-center gap-4 flex-1">
         {inputType === "number" ? <input
           type="number"
           inputMode='numeric'
           className="w-full md:w-2/3 p-2 rounded-lg"
           value={input}
           onChange={handleNumberInput}
           ref={inputRef}
         />:
         <textarea
           type="text"
           className="w-full md:w-2/3 h-32 rounded-lg"
           value={input}
           onChange={handleInput}
           ref={inputRef}
         />
        }
     </div> :
     <div className="flex flex-col items-center md:w-2/3 w-full gap-4 flex-1">
     {inputType === "number" ? <input
       type="number"
       inputMode='numeric'
       className="w-full md:w-2/3 p-2 rounded-lg"
       value={subState[question.id]?.ans}
       onChange={handleSubState}
       ref={inputRef}
     />:
     <textarea
       type="text"
       className="w-full md:w-2/3 h-32 p-2 rounded-lg"
       value={subState[question.id]?.ans}
       onChange={handleSubState}
       ref={inputRef}
     />
    }
   </div>
     }

    {type !== "sub" && <div className="w-full flex justify-between">
       <button
         className="yellowButton py-2 px-4 rounded-3xl font-bold  mb-2 mr-2"
         onClick={handlePrev}
       >
         {t("Back")}
       </button>
       <button
         className="yellowButton py-2 px-4 rounded-3xl font-bold  mb-2 mr-2"
         onClick={handleNext}
       >
         {t("Next")}
       </button>
     </div>}
</div>
  )
}

export default ExplanationComponent
